import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from '@redux-devtools/extension';
import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, reducers);

function loadState () {
	try {
		const serialized = localStorage.getItem('root')
		if (serialized === null) {
			return undefined
		}
		return JSON.parse(serialized)
	}
	catch (error) {
		return undefined
	}
}

let persistedState = loadState();

export const configureStore = createStore(
  persistedReducer,
  persistedState,
  composeWithDevTools()
);

let presistor = persistStore(configureStore);

export type RootState = ReturnType<typeof configureStore.getState>;